import React, { useCallback, useContext, useEffect, useRef, useState } from "react";

import Clarity from "@microsoft/clarity";
import { Layout, message } from "antd";
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "../../assets/css/commons.css";
import "../../assets/css/input.css";
import "../../assets/css/select.css";
import "../../assets/css/contentBar.css";
import "../../assets/css/services/services.css";
import "../../assets/css/users.css";
import { urlParams } from "../../constants/AppConstants";
import NoAccess from "../../pages/noAccess";
import { openServiceNotAuthorizedModal, OTP_MODAL_EXCLUDE_PATHS } from "../../pages/utils/commonUtils";
import { InvalidModal, LicenseInvalidModal } from "../../pages/utils/CommonVessels";
import Dialpad from "../../voice/components/Dialpad";
import { useVoiceContext } from "../../voice/context/VoiceContext";
import { useVoiceNumbers } from "../../voice/hooks/useVoiceNumbers";
import { getCurrentFeature, getCurrentPlanName, useVoiceIntegId } from "../../voice/utils/VoiceUtils";
import { AppContext } from "./../../context/AppContext";
import "../../assets/css/commons.css";
import ImportantAlertBanner from "../custom/ImportantAlertBanner";

const { Content } = Layout;

function getDaysDifference(startDay, endDay) {
  var millisBetween = startDay.getTime() - endDay.getTime();
  var days = millisBetween / (1000 * 3600 * 24);
  return Math.round(Math.abs(days));
}

function Contentbar(props) {
  const { headerBarHeight } = props;
  const location = useLocation();
  const path = location.pathname;
  const [voiceSavedNumbers, setVoiceSavedNumbers] = useState([]);
  const { getVoiceSavedNumbers } = useVoiceNumbers();
  const [callProperties, setCallProperties] = useVoiceContext();
  const navigate = useNavigate();
  const [activateLicense, setActivateLicense] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const [loadDialPad, setLoadDialPad] = useState(true);
  let onBoardingPage = urlParams.get("onBoardingPage");

  const [onBoarding, setOnBoarding] = useState(onBoardingPage === "true");
  const [leftAuthorizeModal, setLeftAuthorizeModal] = useState(false);
  const [allPageContainer, setAllPageContainer] = useState("hs-bg-off-white overflow-auto mainPage");
  const [messageLoaded, setMessageLoaded] = useState(false);
  const [appPropertiesLength, setAppPropertiesLength] = useState();
  const [appProperties] = useContext(AppContext);
  const [searchParams] = useSearchParams();
  let locationHref = window.location.href;
  const fullView = searchParams.get("fullView");
  let sideBar = searchParams.get("sideBar");
  let topBar = searchParams.get("topBar");
  if (navigator.userAgent.includes("HelloSendMobile")) {
    sideBar = "false";
    topBar = "false";
  }

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    let headerValue = "";
    if (pathSegments.length > 2) {
      if (pathSegments.includes("settings") || pathSegments.includes("voice") || pathSegments.includes("messaging") || pathSegments.includes("ai")) {
        if (pathSegments.includes("automation") && pathSegments.includes("logs")) {
          headerValue = "Automation Logs";
        } else {
          headerValue = pathSegments[2];
        }
      } else {
        headerValue = pathSegments[1];
      }
    } else {
      headerValue = pathSegments[1];
    }

    props.setHeaderTitle(headerValue);

    if (fullView === "false" && sideBar === "false") {
      setAllPageContainer("hs-bg-off-white overflow-auto");
    }
  }, [fullView, location.pathname, props, sideBar]);

  const showLicenseBanner = useCallback(
    (content, messageType) => {
      messageApi.open({
        type: messageType,
        content: content,
        duration: 5,
      });
    },
    [messageApi]
  );

  useEffect(() => {
    try {
      if (window.$zoho && window.$zoho.salesiq) {
        window.$zoho.salesiq.visitor.email(appProperties?.currentUserEmail);
      }
    } catch (error) {}
    if (appProperties && appProperties?.companyId && window.clarity) {
      try {
        var identify = appProperties?.companyId + "_" + appProperties?.userId;
        var displayName = appProperties?.userId;
        Clarity.identify(identify, appProperties?.userId, window.location.pathname, displayName);
        if (appProperties?.leftServiceClientDetails?.name) {
          Clarity.setTag("leftService", appProperties?.leftServiceClientDetails?.name);
        }
        Clarity.setTag("companyId", appProperties?.companyId);
        Clarity.setTag("osyncId", appProperties?.osyncId);
        Clarity.setTag("remoteUserId", appProperties?.userId);
        if (
          appProperties?.licenseObj?.licenseDetails?.licenseType === "user" &&
          appProperties?.licenseObj?.licenseDetails?.licenseStatus === 1
        ) {
          Clarity.setTag("userType", "Paid");
          Clarity.setTag("planName", appProperties?.licenseObj?.licenseDetails?.planName);
          Clarity.setTag("usersPurchased", appProperties?.licenseObj?.licenseDetails?.totalUsersPurchased);
        } else {
          Clarity.setTag("userType", "Trial");
        }
      } catch (error) {}
    }
  }, [window.location.pathname, appProperties?.companyId, window.clarity]);

  useEffect(() => {
    if (location.pathname.startsWith("/campaigns")) {
      const newPath = `/messaging${location.pathname}` + location.search;
      navigate(newPath, { replace: true });
    } else if (location.pathname.startsWith("/automation")) {
      const automationPath = (location.pathname = `/messaging${location.pathname}` + location.search);
      navigate(automationPath, { replace: true });
    } else if(location.pathname.startsWith("/voice/team")){
      const newPath = `/settings/teams` + location.search;
      navigate(newPath, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    if (appProperties !== null && appProperties !== undefined) {
      if (appProperties.licenseObj != null) {
        let licenseInfo = appProperties.licenseObj.licenseDetails;
        if (licenseInfo !== null && licenseInfo !== undefined) {
          var licenseStatus = licenseInfo.licenseStatus;
          if ((licenseStatus === 4 || licenseStatus === 5) && !messageLoaded) {
            var currentDate = new Date();
            var trialStartDate = new Date(licenseInfo.trialStartDate ?? licenseInfo.createdTime);
            var trialExpiryDate = "";
            if (licenseInfo.trialDays) {
              trialExpiryDate = trialStartDate.setDate(trialStartDate.getDate() + licenseInfo.trialDays);
            } else {
              trialExpiryDate = trialStartDate.setDate(trialStartDate.getDate() + 3);
            }
            var trialExpiryDateObj = new Date(trialExpiryDate);
            var daysDifference = getDaysDifference(trialExpiryDateObj, currentDate);
            let messageType = "warning";
            let messageContent = "Trial expires in " + daysDifference + " days";
            let isTrialStarted = localStorage.getItem("Trial");
            if (daysDifference === 3) {
              if (isTrialStarted === null && licenseInfo?.hasTrialStarted) {
                messageContent = "Trial activated successfully. Enjoy your 3 days free trial.";
                messageType = "success";
                localStorage.setItem("Trial", true);
                showLicenseBanner(messageContent, messageType);
              }
              setMessageLoaded(true);
            }
          } else if (licenseStatus > 10 && locationHref.indexOf("/content") === -1 && locationHref.indexOf("account/helloSend/active") === -1) {
            setActivateLicense(true);
          }
        }
      }
      if (appProperties.authorizeObj) {
        let authObj = appProperties.authorizeObj;
        let leftAuth = authObj?.left?.auth?.authorized;
        let nameToBeCheckedInThePath = authObj?.right?.service_name === "unipile_whatsapp" ? "personal_whatsapp" : authObj?.right?.service_name;
        const avoidPagesForAuth = [
          "/channels",
          "/channels/textsms",
          `/channels/textsms/${nameToBeCheckedInThePath}`,
          `/settings/channels/textsms/${nameToBeCheckedInThePath}`,
          `/settings/channels/${nameToBeCheckedInThePath}`,
        ];
        function shouldAvoidAuth(path) {
          return avoidPagesForAuth.some((avoidPath) => {
            if (path === avoidPath) return true;
            if (path.startsWith(avoidPath + "/")) {
              const remainingPath = path.slice(avoidPath.length + 1);
              return !remainingPath.includes("/");
            }
            return false;
          });
        }

        if (leftAuth === false && locationHref.indexOf("account/helloSend/active") === -1 && locationHref.indexOf("/authorize") === -1) {
          setLeftAuthorizeModal(true);
        } else {
          setLeftAuthorizeModal(false);
        }
        let rightAuth = authObj?.right?.auth?.authorized;
        let rightServiceName = authObj?.right?.service_name;
        if (
          rightAuth === false &&
          locationHref.indexOf("/account/" + appProperties.righServiceName + "/authorize") === -1 &&
          locationHref.indexOf("/account") === -1 &&
          locationHref.indexOf("/authorize") === -1 &&
          locationHref.indexOf("/twilio_voice") === -1 &&
          locationHref.indexOf("/guide") === -1 &&
          licenseStatus < 11 &&
          rightServiceName !== "chatgpt" &&
          !shouldAvoidAuth(location.pathname)
        ) {
          if (!authObj?.right?.auth?.ignoreAuthorizedCheck) {
            openServiceNotAuthorizedModal(
              { service_name: rightServiceName, service_display_name: authObj?.right?.service_display_name },
              appProperties
            );
          }
        }
      } else if (licenseStatus > 10 && locationHref.indexOf("/content") === -1 && locationHref.indexOf("/account/helloSend/phone") === -1) {
        setActivateLicense(true);
      }
    }
  }, [
    appProperties.licenseObj,
    appProperties.authorizeObj,
    appProperties.osyncId,
    location.pathname,
    locationHref,
    messageLoaded,
    showLicenseBanner,
    leftAuthorizeModal,
  ]);

  useEffect(() => {
    setAppPropertiesLength(Object.keys(appProperties).length);
  }, [appProperties]);
  const voiceIntegId = useVoiceIntegId(appProperties);
  useEffect(() => {
    const currentPlanName = getCurrentFeature(appProperties);
    let currentPathName = location.pathname;
    if (voiceIntegId && currentPlanName !== "Message" && callProperties?.savedNumbers?.length === 0 && !currentPathName.includes("sendsms")) {
      getVoiceSavedNumbers("all")
        .then((response) => {
          if (response) {
            setVoiceSavedNumbers(response?.numberVoiceConfigurationEntities);
          }
        })
        .catch((err) => {});
    }
  }, [voiceIntegId]);

  const [shrinkView] = useState(urlParams.get("fullView") === "false");
  const alertBannerRef = useRef(null);

  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    if(alertBannerRef.current) {
      setBannerHeight(alertBannerRef.current?.clientHeight || 0);
    }
  }, [alertBannerRef.current?.clientHeight]);

  return (
    <>
      {/* {contextHolder} */}
      {activateLicense ? <LicenseInvalidModal /> : null}
      {leftAuthorizeModal === true && !OTP_MODAL_EXCLUDE_PATHS.includes(location.pathname) && urlParams.get("topBar") === "false" ? (
        <InvalidModal open={leftAuthorizeModal} />
      ) : null}

      <Content>
        <div ref={alertBannerRef}>
          <ImportantAlertBanner
            bannerRef={alertBannerRef}
            onClose={() => {
              setBannerHeight(0);
            }}
          />
        </div>
        <div
          style={{
            height:
              (sideBar === "false" && topBar === "false") ||
              OTP_MODAL_EXCLUDE_PATHS.includes(location.pathname) ||
              path.includes("voice/dialpad") ||
              path.includes("web/signin") ||
              path.includes("web/signup") ||
              path.includes("web/apps")
              ? `calc(100dvh - ${bannerHeight > 0 ? bannerHeight + 1 : 0}px)` // +1px to avoid overflow scrolling
              : `calc(100dvh - ${headerBarHeight + bannerHeight}px)`,
          }}
          className={allPageContainer}
        >
          {loadDialPad &&
          (Array.isArray(voiceSavedNumbers) || Array.isArray(callProperties?.savedNumbers)) &&
          (voiceSavedNumbers?.length > 0 || callProperties?.savedNumbers?.length > 0) &&
          !path.includes("sendsms") &&
          !path.includes("voice/dialpad") &&
          !OTP_MODAL_EXCLUDE_PATHS.includes(location.pathname) &&
          !(path.includes("/campaign") && shrinkView) &&
          getCurrentPlanName(appProperties?.licenseObj?.licenseDetails?.planName) !== "Message" ? (
            <Dialpad />
          ) : null}
          {appPropertiesLength > 0 && (props.accessDenied ? <NoAccess setAccessDenied={props.setAccessDenied} /> : <Outlet />)}
        </div>
      </Content>
    </>
  );
}

export default Contentbar;
